import { Box, Button, Container, Typography } from '@mui/material'
import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode | string
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      if (typeof this.props.fallback === 'string') {
        return (
          <Container maxWidth='sm'>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                gap: 2,
                textAlign: 'center'
              }}
            >
              <Typography variant='h4' color='error'>
                {this.props.fallback}
              </Typography>
              <Typography variant='body1' color='text.secondary'>
                {this.state.error?.message}
              </Typography>
              <Button variant='contained' onClick={() => window.location.reload()}>
                Reload Page
              </Button>
            </Box>
          </Container>
        )
      }
      return this.props.fallback
    }

    return this.props.children
  }
}
